export default "__VITE_PUBLIC_ASSET__3ce1d2a7__"